module.exports = __webpack_public_path__ + "static/media/info2.f0d5932b.png";